module.exports = __webpack_public_path__ + "static/media/milos_jovanovik.f89b7207.jpeg";